import React from 'react';

import { Button, createStyles, Grid, Icon, makeStyles, Paper, Theme, Typography } from '@material-ui/core';

import { ClientContext } from '../../ClientContext';
import { OrganogramList } from '../components/OrganogramList';
import { theme } from '../../../../theme';
import { TableEmpty } from '../../../../shared/components/TableEmpty';
import { ClientOrganogramModal } from '../components/ClientOrganogramModal';

const useStyles = makeStyles((theme: Theme) => createStyles({
    textButton: {
        paddingLeft: 0,
        '&:hover': {
            textDecorationLine: 'underline',
        },
    },
    organogramHeader: {
        minHeight: theme.spacing(4),
        borderBottom: '1px solid rgba(0, 0, 0, .125)',
        fontWeight: 'bold',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
}));

export function ClientOrganogram() {
    const classes = useStyles();
    const clientContext = React.useContext(ClientContext);

    const [showAddOrganogramDialog, setShowAddOrganogramDialog] = React.useState<boolean>(false);

    const getAddNewButton = () => {
        return (
            <Grid item xs={12}>
                <Button
                    onClick={() => setShowAddOrganogramDialog(true)}
                    className={classes.textButton}
                    startIcon={<Icon color='primary'>add</Icon>}>
                    CADASTRAR NOVA MARCA
                </Button>                        
            </Grid> 
        ); 
    };    

    const getOrganogram = () => {
        return (
            <>
                <Grid item xs={12}>
                    {clientContext.flatOrganogram.length > 0 ? (
                        <Paper elevation={1}>
                            <Grid 
                                container 
                                direction='row'
                                justify="space-between"
                                alignItems="center">
                                <Grid item xs={8} className={classes.organogramHeader} style={{ paddingLeft: theme.spacing(2) }}>                           
                                    <Typography variant='subtitle2' >Item</Typography>
                                </Grid>
                                <Grid item xs={2} className={classes.organogramHeader}>
                                    <Typography variant='subtitle2' >Concorrente</Typography>
                                </Grid>
                                <Grid item xs={2} className={classes.organogramHeader}>
                                    <Typography variant='subtitle2' >Ações</Typography>
                                </Grid>
                                <OrganogramList listOrg={clientContext.flatOrganogram} parent={null} level={1} textLevel={''}/>
                            </Grid>
                        </Paper>
                    ) : (
                        <TableEmpty 
                            displayText='Organograma não cadastrado'
                            cssProperties={{
                                minHeight: '150px',
                            }} 
                        />
                    )
                    }
                </Grid>
            </>
        );
    };
    
    return (
        <>
            <Grid container direction="column" spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="subtitle1">
                    Organograma
                    </Typography>
                </Grid>  
        
                { getAddNewButton() }
                { getOrganogram() }
            </Grid>

            <ClientOrganogramModal
                organogramLevelText={'Marcas'}
                itemText={'as marcas'}
                forText={'este cliente.'}
                destinationText={'Marcas'}
                originOrganogram={null}
                showAddOrganogramDialog={showAddOrganogramDialog}
                setShowAddOrganogramDialog={setShowAddOrganogramDialog}
            />
        </>
    );

}
